<template>
  <div>
    <h-loading v-if="isLoading" />

    <div v-else>
      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.code') }}
          </h6>
          <span class="body-2">
            {{ realty.code }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.description') }}
          </h6>
          <span class="body-2">
            {{ realty.description ? realty.description : '---' }}
          </span>
        </v-col>
      </v-row>

      <v-divider class="mt-1 mb-3" />

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.address') }}
          </h6>
          <span class="body-2">
            {{ realty.address ? realty.address : '---' }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.additionalAddressData') }}
          </h6>
          <span class="body-2">
            {{
              realty.additional_address_data
                ? realty.additional_address_data
                : '---'
            }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.city') }}
          </h6>
          <span class="body-2">
            {{ realty.city ? realty.city.name : '' }}
          </span>
        </v-col>
      </v-row>

      <v-divider class="mt-1 mb-3" />

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.totalArea') }}
          </h6>
          <span class="body-2">
            {{ realty.square_meters ? `${realty.square_meters} m²` : '---' }}
          </span>
        </v-col>

        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.privateArea') }}
          </h6>
          <span class="body-2">
            {{
              realty.private_area_meters
                ? `${realty.private_area_meters} m²`
                : '---'
            }}
          </span>
        </v-col>

        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.type') }}
          </h6>
            {{
              realty.realty_type
                ? $t(`realty.type.${realty.realty_type}`)
                : '---'
            }}
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.furniture') }}
          </h6>
          <span class="body-2">
            {{ furnishingLabel }}
          </span>
        </v-col>

        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('realty.label.trousseau') }}
          </h6>
          <span class="body-2">
            {{ convertBooleanToString(realty.trousseau) }}
          </span>
        </v-col>

        <v-col>
          <h6 class="text-uppercase grey--text">Estado da pintura</h6>
          <span class="body-2">
            {{
              realty.painting_status
                ? this.$t(`realty.paintingStatus.${realty.painting_status}`)
                : '---'
            }}
          </span>
        </v-col>
      </v-row>

      <v-divider v-if="realtyPhotos.length" class="mt-1 mb-3" />

      <v-row>
        <v-col
          v-for="photo in realtyPhotos"
          :key="photo.id"
          cols="6"
          sm="4"
        >
          <a :href="photo.external_url" target="_blank">
            <img
              :src="photo.thumbnail_url"
              class="d-block rounded-lg mw-200"
              height="80"
            >
          </a>
        </v-col>
      </v-row>

      <template v-if="realtyVideos.length">
        <v-divider class="mt-1 mb-3" />

        <h6 class="text-uppercase grey--text mb-2">{{ $t('upload.videos') }}</h6>

        <v-row>
          <v-col
            v-for="video in realtyVideos"
            :key="video.id"
            cols="6"
            sm="4"
          >
            <a :href="video.url" target="_blank" rel="noopener noreferrer" class="video-link">
              <!-- Thumbnail do YouTube sai do id, sem chamar API; Vimeo exigiria oEmbed e fica com
                   o ícone -->
              <img
                v-if="thumbnailOf(video)"
                :src="thumbnailOf(video)"
                class="d-block rounded-lg mw-200"
                height="80"
              >
              <div
                v-else
                class="grey lighten-2 rounded-lg d-flex align-center justify-center"
                style="height: 80px"
              >
                <v-icon color="grey darken-1">mdi-video</v-icon>
              </div>

              <span class="caption d-block text-truncate mt-1" :title="video.title || video.url">
                {{ video.title || $t('realty.label.videoWithoutTitle') }}
              </span>
            </a>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { videoThumbnail } from '@/util/videoUrl'
import { furnishingKey } from '@/util/furnishing'

export default {
  name: 'RealtyResume',

  props: {
    realty: {
      required: true,
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'realtyPhotos', 'realtyVideos']),

    furnishingLabel() {
      const key = furnishingKey(this.realty)
      return key ? this.$t(key) : '---'
    },
  },

  methods: {
    ...mapActions(['fetchRealtyPhotos', 'fetchRealtyVideos']),

    thumbnailOf(video) {
      return videoThumbnail(video)
    },

    convertBooleanToString(booleanValue) {
      return booleanValue ? 'Sim' : 'Não'
    },

    getUrl(photoIndex) {
      const photo = this.selectedPhotos[photoIndex]
      if (!photo) return
      return URL.createObjectURL(photo)
    },
  },

  watch: {
    realty(newValue) {
      this.fetchRealtyPhotos(newValue.id)
      this.fetchRealtyVideos(newValue.id)
    }
  }
}
</script>

<style scoped>
.video-link {
  text-decoration: none;
  color: inherit;
}
</style>
